<template>
<div class="chapter">
<div class="inner_page">
<section class="div_autre" epub:type="preamble"><div class="pre" id="pre-004"><h1 class="pre_tit" epub:type="title"><span><span epub:type="pagebreak" id="page_14" title="14"></span> </span></h1>
<div class="exergues"><div class="exer"><p class="txt_courant_justif">What am <i>I</i> to you, that you should command me to love you and, if I do not,</p>
<p class="txt_courant_justif last">you should be angry with me and threaten great miseries?</p>
<div class="exer_source">Augustine, <i>Confessions</i>, I, 5</div>
</div>
</div>
<div class="dev"><p class="bl"> </p>
</div>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// pre5.vue?c736d6ee